import { render, staticRenderFns } from "./leave-page-warning-dialog.vue?vue&type=template&id=0a730a0a&scoped=true"
import script from "./leave-page-warning-dialog.vue?vue&type=script&lang=ts"
export * from "./leave-page-warning-dialog.vue?vue&type=script&lang=ts"
import style0 from "./leave-page-warning-dialog.vue?vue&type=style&index=0&id=0a730a0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a730a0a",
  null
  
)

export default component.exports